
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.719 2.281l6.75 6.75C12.154 8.419 14.007 8 16 8c8.395 0 14.494 7.044 14.75 7.344l.625.719-.656.656c-.193.192-3.247 3.135-7.344 5.219l6.344 6.344-1.438 1.438-8.688-8.719L8.468 9.876 2.28 3.72zM16 10c-1.389 0-2.697.254-3.938.625l2.063 2.063A2.992 2.992 0 0116 12c1.654 0 3 1.346 3 3 0 .71-.273 1.362-.688 1.875l2.844 2.844A6.966 6.966 0 0023 15c0-1.3-.386-2.556-1.063-3.656C20.161 10.556 18.164 10 15.999 10zm-9.375.875l2.563 2.563A6.746 6.746 0 009 15.001c0 3.565 2.68 6.54 6.219 6.938l.094.031c.466.039.908.039 1.375 0l.125-.031c.261-.029.531-.068.781-.125l1.719 1.719c-.778.198-1.577.343-2.375.406h-.063c-.29.025-.585.063-.875.063s-.585-.037-.875-.063h-.063c-6.964-.555-13.495-6.934-13.781-7.219l-.656-.656.625-.719c.144-.17 2.137-2.479 5.375-4.469zm.656 1.969a24.434 24.434 0 00-3.875 3.094 32.712 32.712 0 004.781 3.5A8.929 8.929 0 016.999 15c0-.737.107-1.452.281-2.156zm17.438 0c.173.702.281 1.421.281 2.156 0 1.614-.438 3.12-1.188 4.438a32.299 32.299 0 004.75-3.469 23.858 23.858 0 00-3.844-3.125zM16 14a.951.951 0 00-.438.125l1.313 1.313A.951.951 0 0017 15c0-.551-.448-1-1-1z"}})])
          )
        }
      }
    